import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import { getHandler } from './utils';
import { DEFAULT_TYPE, DEFAULT_AUTO_COMPLETE } from './config';
import type { TPureInput } from './models';

export const PureInput: FC<TPureInput> = ({
    autoComplete = DEFAULT_AUTO_COMPLETE,
    className = '',
    dataTestId = 'input',
    disabled,
    error,
    valid,
    forwardedRef,
    onBlur,
    onChange,
    onFocus,
    onKeyDown,
    onMouseDown,
    onMouseUp,
    onPaste,
    paddingleft = '',
    styles,
    type = DEFAULT_TYPE,
    value = '',
    name = '',
    hasFloatingLabel = true,
    ...rest
}) => (
    <input
        {...rest}
        ref={forwardedRef}
        autoComplete={autoComplete}
        className={cn(styles.input, className, {
            [styles.hasFloatingLabel]: hasFloatingLabel,
            [styles.error]: error,
            [styles.valid]: valid,
            [styles.disabled]: disabled,
        })}
        data-test-id={dataTestId}
        disabled={disabled}
        name={name}
        onBlur={getHandler(onBlur)}
        onChange={getHandler(onChange)}
        onFocus={getHandler(onFocus)}
        onKeyDown={getHandler(onKeyDown)}
        onMouseDown={getHandler(onMouseDown)}
        onMouseUp={getHandler(onMouseUp)}
        onPaste={getHandler(onPaste)}
        style={{ paddingLeft: paddingleft }}
        type={type}
        value={value}
    />
);
